import {
	BumpoutEdgeTypes,
	DeckBoxEdgeTypes,
	LandingEdgeTypes,
	StairEdgeTypes,
} from '../context/DeckContext';

export const getEdgeTypes = (blockType) => {
	if (blockType === 'Bumpout') {
		return BumpoutEdgeTypes;
	} else if (blockType === 'DeckBox') {
		return DeckBoxEdgeTypes;
	} else if (blockType === 'Stair') {
		return StairEdgeTypes;
	} else if (blockType === 'Landing') {
		return LandingEdgeTypes;
	}
	return [];
};

export const getOppositeEdge = (edge) =>
	({
		Top: 'Bottom',
		Bottom: 'Top',
		Left: 'Right',
		Right: 'Left',
	})[edge];

export const getAdjacentEdges = (edge) =>
	({
		Top: ['Left', 'Right'],
		Bottom: ['Left', 'Right'],
		Left: ['Top', 'Bottom'],
		Right: ['Top', 'Bottom'],
	})[edge];

export const isSameEdge = (edge1, edge2) => {
	if (!edge1 || !edge2) return false;
	return edge1.type === edge2.type && edge1.label === edge2.label;
};
